import {type PlayerColorWithoutNone} from '../../utils/gameColors.ts'
import {useGameStore} from '../GameStoreContext.ts'

export const useMyPerspectiveColor = (): PlayerColorWithoutNone => {
    const myColor = useGameStore((state) => state.myColor)
    const firstPlayerColor = useGameStore((state) => state.gameDetails.playOrder[0])
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    if(isMyColorSpectator) return firstPlayerColor as PlayerColorWithoutNone
    return myColor as PlayerColorWithoutNone
}
